import { Container } from "components/layout/Container";
import { Title } from "components/typography/Title";
import { Button } from "components/UI/Buttons/Button";
import { ArticleCard } from "../article/ArticleCard";
import styles from "./HighlightCategory.module.scss";
import { ArticleListItemData } from "@/types/strapi/article";

type HighlightCategoryProps = { category: { heading: string; url: string; articles: ArticleListItemData[] } };

export const HighlightCategory = ({ category }: HighlightCategoryProps) => {
  const { heading, url, articles } = category;

  return (
    <div className={styles.main}>
      <Container>
        <Title level={2} className={styles.heading}>
          {heading}
        </Title>
      </Container>
      <div className={styles.listWrapper}>
        <Container className={styles.container}>
          <div className={styles.list}>
            {articles.map((item) => (
              <ArticleCard key={item.slug} className={styles.item} showSubcategory {...item} />
            ))}
          </div>
        </Container>
      </div>
      <Container>
        <Button
          // icon="arrow-right"
          iconPosition="suffix"
          type="primary"
          href={url}
          className={styles.button}
        >
          Read {heading}
        </Button>
      </Container>
    </div>
  );
};
